/**
 * Shared styles for settings components
 * ใช้ร่วมกันในทุก block settings เพื่อลด code ซ้ำซ้อน
 */

import { SxProps, Theme } from "@mui/material";

// Label style for settings fields
export const labelStyle: React.CSSProperties = {
  display: "block",
  fontSize: "0.875rem",
  fontWeight: 500,
  marginBottom: "4px",
  color: "#374151",
};

// Input style for native HTML inputs
export const inputStyle: React.CSSProperties = {
  width: "100%",
  padding: "6px 8px",
  border: "1px solid #d1d5db",
  borderRadius: "4px",
  fontSize: "0.875rem",
  boxSizing: "border-box",
};

// Textarea style
export const textareaStyle: React.CSSProperties = {
  ...inputStyle,
  minHeight: "80px",
  resize: "vertical",
};

// Select style
export const selectStyle: React.CSSProperties = {
  ...inputStyle,
  cursor: "pointer",
};

// Color input style
export const colorInputStyle: React.CSSProperties = {
  width: "100%",
  height: "40px",
  borderRadius: "4px",
  border: "1px solid #d1d5db",
  cursor: "pointer",
  padding: 0,
};

// Checkbox container style
export const checkboxContainerStyle: React.CSSProperties = {
  display: "flex",
  alignItems: "center",
  gap: "8px",
};

// Checkbox style
export const checkboxStyle: React.CSSProperties = {
  width: "16px",
  height: "16px",
};

// Settings section container
export const settingsSectionStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  gap: "16px",
};

// Grid 2 columns
export const gridTwoColumnsStyle: React.CSSProperties = {
  display: "grid",
  gridTemplateColumns: "1fr 1fr",
  gap: "8px",
};

// Selected outline style for components
// Using a plain object that can be spread into sx props
export const selectedOutlineSx = {
  outline: "2px dashed",
  outlineColor: "primary.main",
} as const;

// Text overflow styles
export const textOverflowStyle: React.CSSProperties = {
  wordWrap: "break-word",
  overflowWrap: "break-word",
};

// Button styles for settings
export const addButtonStyle: React.CSSProperties = {
  marginTop: "8px",
  padding: "8px 16px",
  backgroundColor: "#dbeafe",
  color: "#2563eb",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "0.875rem",
  fontWeight: 500,
  width: "100%",
};

export const removeButtonStyle: React.CSSProperties = {
  padding: "4px 8px",
  backgroundColor: "#fee2e2",
  color: "#dc2626",
  border: "none",
  borderRadius: "4px",
  cursor: "pointer",
  fontSize: "12px",
};

// Item card style (for lists in settings)
export const itemCardStyle: React.CSSProperties = {
  padding: "12px",
  backgroundColor: "#f9fafb",
  borderRadius: "8px",
};

// MUI TextField sx for settings
export const textFieldSx: SxProps<Theme> = {
  "& .MuiOutlinedInput-root": {
    bgcolor: "grey.50",
    "& fieldset": { borderColor: "grey.300" },
    "&:hover fieldset": { borderColor: "grey.400" },
    "&.Mui-focused fieldset": { borderColor: "primary.main" },
  },
  "& .MuiInputBase-input": { color: "text.primary" },
};
